<footer class="bg-linear-to-r from-[#111] via-slate-900 to-[#111] pt-7 pb-6 px-4 md:px-12 tracking-wide">
  <div class="max-w-6xl mx-auto">
    <!-- Top Section -->
    <div class="max-w-2xl mx-auto text-center">
      <!-- Logo -->
      <a routerLink="/" class="inline-block text-2xl lg:text-5xl text-white font-extrabold" aria-label="Home">
        {{companyName()}}
      </a>
      
      <!-- Social Links -->
      @if (hasSocialLinks()) {
        <ul class="flex flex-wrap justify-center gap-6 mt-2 lg:mt-5">
          <!-- Facebook -->
          @if (contactInfo()?.facebookLink) {
            <li class="list-none">
              <a 
                [href]="getFullUrl(contactInfo()!.facebookLink || '')" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <svg xmlns="http://www.w3.org/2000/svg" class="fill-blue-600 w-8 h-8 hover:opacity-80 transition-opacity" viewBox="0 0 49.652 49.652" aria-hidden="true">
                  <path d="M24.826 0C11.137 0 0 11.137 0 24.826c0 13.688 11.137 24.826 24.826 24.826 13.688 0 24.826-11.138 24.826-24.826C49.652 11.137 38.516 0 24.826 0zM31 25.7h-4.039v14.396h-5.985V25.7h-2.845v-5.088h2.845v-3.291c0-2.357 1.12-6.04 6.04-6.04l4.435.017v4.939h-3.219c-.524 0-1.269.262-1.269 1.386v2.99h4.56z"/>
                </svg>
              </a>
            </li>
          }
          
          <!-- LinkedIn -->
          @if (contactInfo()?.othersLink1) {
            <li class="list-none">
              <a 
                [href]="getFullUrl(contactInfo()!.othersLink1 || '')" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 hover:scale-105 transition-transform" viewBox="0 0 112.196 112.196" aria-hidden="true">
                  <circle cx="56.098" cy="56.097" r="56.098" fill="#007ab9"/>
                  <path fill="#fff" d="M89.616 60.611v23.128H76.207V62.161c0-5.418-1.936-9.118-6.791-9.118-3.705 0-5.906 2.491-6.878 4.903-.353.862-.444 2.059-.444 3.268v22.524h-13.41s.18-36.546 0-40.329h13.411v5.715c-.027.045-.065.089-.089.132h.089v-.132c1.782-2.742 4.96-6.662 12.085-6.662 8.822 0 15.436 5.764 15.436 18.149zm-54.96-36.642c-4.587 0-7.588 3.011-7.588 6.967 0 3.872 2.914 6.97 7.412 6.97h.087c4.677 0 7.585-3.098 7.585-6.97-.089-3.956-2.908-6.967-7.496-6.967zm-6.791 59.77H41.27v-40.33H27.865v40.33z"/>
                </svg>
              </a>
            </li>
          }
          
          <!-- Instagram -->
          @if (contactInfo()?.othersLink2) {
            <li class="list-none">
              <a 
                [href]="getFullUrl(contactInfo()!.othersLink2 || '')" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 hover:scale-105 transition-transform" viewBox="0 0 152 152" aria-hidden="true">
                  <linearGradient id="instagram-gradient" x1="22.26" x2="129.74" y1="22.26" y2="129.74">
                    <stop offset="0" stop-color="#fae100"/>
                    <stop offset=".15" stop-color="#fcb720"/>
                    <stop offset=".3" stop-color="#ff7950"/>
                    <stop offset=".5" stop-color="#ff1c74"/>
                    <stop offset="1" stop-color="#6c1cd1"/>
                  </linearGradient>
                  <rect width="152" height="152" fill="url(#instagram-gradient)" rx="76"/>
                  <g fill="#fff">
                    <path fill="#ffffff10" d="M133.2 26c-11.08 20.34-26.75 41.32-46.33 60.9S46.31 122.12 26 133.2q-1.91-1.66-3.71-3.46A76 76 0 1 1 129.74 22.26q1.8 1.8 3.46 3.74z"/>
                    <path d="M94 36H58a22 22 0 0 0-22 22v36a22 22 0 0 0 22 22h36a22 22 0 0 0 22-22V58a22 22 0 0 0-22-22zm15 54.84A18.16 18.16 0 0 1 90.84 109H61.16A18.16 18.16 0 0 1 43 90.84V61.16A18.16 18.16 0 0 1 61.16 43h29.68A18.16 18.16 0 0 1 109 61.16z"/>
                    <path d="m90.59 61.56-.19-.19-.16-.16A20.16 20.16 0 0 0 76 55.33 20.52 20.52 0 0 0 55.62 76a20.75 20.75 0 0 0 6 14.61 20.19 20.19 0 0 0 14.42 6 20.73 20.73 0 0 0 14.55-35.05zM76 89.56A13.56 13.56 0 1 1 89.37 76 13.46 13.46 0 0 1 76 89.56zm26.43-35.18a4.88 4.88 0 0 1-4.85 4.92 4.81 4.81 0 0 1-3.42-1.43 4.93 4.93 0 0 1 3.43-8.39 4.82 4.82 0 0 1 3.09 1.12l.1.1a3.05 3.05 0 0 1 .44.44l.11.12a4.92 4.92 0 0 1 1.1 3.12z"/>
                  </g>
                </svg>
              </a>
            </li>
          }
          
          <!-- Twitter/X -->
          @if (contactInfo()?.facebookLink) {
            <li class="list-none">
              <a 
                [href]="getFullUrl(contactInfo()!.facebookLink || '')" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Twitter"
              >
                <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 hover:scale-105 transition-transform" viewBox="0 0 1227 1227" aria-hidden="true">
                  <path d="M613.5 0C274.685 0 0 274.685 0 613.5S274.685 1227 613.5 1227 1227 952.315 1227 613.5 952.315 0 613.5 0z"/>
                  <path fill="#fff" d="m680.617 557.98 262.632-305.288h-62.235L652.97 517.77 470.833 252.692H260.759l275.427 400.844-275.427 320.142h62.239l240.82-279.931 192.35 279.931h210.074L680.601 557.98zM345.423 299.545h95.595l440.024 629.411h-95.595z"/>
                </svg>
              </a>
            </li>
          }
        </ul>
      }
    </div>

    <!-- Contact Info Grid -->
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mt-2 lg:mt-5">
      <!-- Phone -->
      <div class="flex items-center">
        <div class="bg-gray-300 h-10 w-10 rounded-full flex items-center justify-center shrink-0" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 fill-black" viewBox="0 0 482.6 482.6">
            <path d="M98.339 320.8c47.6 56.9 104.9 101.7 170.3 133.4 24.9 11.8 58.2 25.8 95.3 28.2 2.3.1 4.5.2 6.8.2 24.9 0 44.9-8.6 61.2-26.3.1-.1.3-.3.4-.5 5.8-7 12.4-13.3 19.3-20 4.7-4.5 9.5-9.2 14.1-14 21.3-22.2 21.3-50.4-.2-71.9l-60.1-60.1c-10.2-10.6-22.4-16.2-35.2-16.2-12.8 0-25.1 5.6-35.6 16.1l-35.8 35.8c-3.3-1.9-6.7-3.6-9.9-5.2-4-2-7.7-3.9-11-6-32.6-20.7-62.2-47.7-90.5-82.4-14.3-18.1-23.9-33.3-30.6-48.8 9.4-8.5 18.2-17.4 26.7-26.1 3-3.1 6.1-6.2 9.2-9.3 10.8-10.8 16.6-23.3 16.6-36s-5.7-25.2-16.6-36l-29.8-29.8c-3.5-3.5-6.8-6.9-10.2-10.4-6.6-6.8-13.5-13.8-20.3-20.1-10.3-10.1-22.4-15.4-35.2-15.4-12.7 0-24.9 5.3-35.6 15.5l-37.4 37.4c-13.6 13.6-21.3 30.1-22.9 49.2-1.9 23.9 2.5 49.3 13.9 80 17.5 47.5 43.9 91.6 83.1 138.7zm-72.6-216.6c1.2-13.3 6.3-24.4 15.9-34l37.2-37.2c5.8-5.6 12.2-8.5 18.4-8.5 6.1 0 12.3 2.9 18 8.7 6.7 6.2 13 12.7 19.8 19.6 3.4 3.5 6.9 7 10.4 10.6l29.8 29.8c6.2 6.2 9.4 12.5 9.4 18.7s-3.2 12.5-9.4 18.7c-3.1 3.1-6.2 6.3-9.3 9.4-9.3 9.4-18 18.3-27.6 26.8l-.5.5c-8.3 8.3-7 16.2-5 22.2.1.3.2.5.3.8 7.7 18.5 18.4 36.1 35.1 57.1 30 37 61.6 65.7 96.4 87.8 4.3 2.8 8.9 5 13.2 7.2 4 2 7.7 3.9 11 6 .4.2.7.4 1.1.6 3.3 1.7 6.5 2.5 9.7 2.5 8 0 13.2-5.1 14.9-6.8l37.4-37.4c5.8-5.8 12.1-8.9 18.3-8.9 7.6 0 13.8 4.7 17.7 8.9l60.3 60.2c12 12 11.9 25-.3 37.7-4.2 4.5-8.6 8.8-13.3 13.3-7 6.8-14.3 13.8-20.9 21.7-11.5 12.4-25.2 18.2-42.9 18.2-1.7 0-3.5-.1-5.2-.2-32.8-2.1-63.3-14.9-86.2-25.8-62.2-30.1-116.8-72.8-162.1-127-37.3-44.9-62.4-86.7-79-131.5-10.3-27.5-14.2-49.6-12.6-69.7z"/>
          </svg>
        </div>
        <div class="text-slate-300 text-sm ml-3">
          <span class="block text-slate-400 text-xs">Phone</span>
          @if (contactInfo()?.phoneNumber1) {
            <a [href]="'tel:' + contactInfo()!.phoneNumber1" class="font-medium hover:text-white transition-colors block">
              {{ contactInfo()!.phoneNumber1 }}
            </a>
          }
          @if (contactInfo()?.phoneNumber2) {
            <a [href]="'tel:' + contactInfo()!.phoneNumber2" class="font-medium hover:text-white transition-colors block mt-1">
              {{ contactInfo()!.phoneNumber2 }}
            </a>
          }
          @if (contactInfo()?.phoneNumber3) {
            <a [href]="'tel:' + contactInfo()!.phoneNumber3" class="font-medium hover:text-white transition-colors block mt-1">
              {{ contactInfo()!.phoneNumber3 }}
            </a>
          }
        </div>
      </div>

      <!-- Email -->
      <div class="flex items-center">
        <div class="bg-gray-300 h-10 w-10 rounded-full flex items-center justify-center shrink-0" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 fill-black" viewBox="0 0 479.058 479.058">
            <path d="M434.146 59.882H44.912C20.146 59.882 0 80.028 0 104.794v269.47c0 24.766 20.146 44.912 44.912 44.912h389.234c24.766 0 44.912-20.146 44.912-44.912v-269.47c0-24.766-20.146-44.912-44.912-44.912zm0 29.941c2.034 0 3.969.422 5.738 1.159L239.529 264.631 39.173 90.982a14.902 14.902 0 0 1 5.738-1.159zm0 299.411H44.912c-8.26 0-14.971-6.71-14.971-14.971V122.615l199.778 173.141c2.822 2.441 6.316 3.655 9.81 3.655s6.988-1.213 9.81-3.655l199.778-173.141v251.649c-.001 8.26-6.711 14.97-14.971 14.97z"/>
          </svg>
        </div>
        <div class="text-slate-300 text-sm ml-3">
          <span class="block text-slate-400 text-xs">Email</span>
          @if (contactInfo()?.email) {
            <a [href]="'mailto:' + contactInfo()!.email" class="font-medium hover:text-white transition-colors block truncate">
              {{ contactInfo()!.email }}
            </a>
          }
        </div>
      </div>

      <!-- Address -->
      <div class="flex items-center">
        <div class="bg-gray-300 h-10 w-10 rounded-full flex items-center justify-center shrink-0" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 fill-black" viewBox="0 0 368.16 368.16">
            <path d="M184.08 0c-74.992 0-136 61.008-136 136 0 24.688 11.072 51.24 11.536 52.36 3.576 8.488 10.632 21.672 15.72 29.4l93.248 141.288c3.816 5.792 9.464 9.112 15.496 9.112s11.68-3.32 15.496-9.104l93.256-141.296c5.096-7.728 12.144-20.912 15.72-29.4.464-1.112 11.528-27.664 11.528-52.36 0-74.992-61.008-136-136-136zM293.8 182.152c-3.192 7.608-9.76 19.872-14.328 26.8l-93.256 141.296c-1.84 2.792-2.424 2.792-4.264 0L88.696 208.952c-4.568-6.928-11.136-19.2-14.328-26.808-.136-.328-10.288-24.768-10.288-46.144 0-66.168 53.832-120 120-120s120 53.832 120 120c0 21.408-10.176 45.912-10.28 46.152z"/>
            <path d="M184.08 64.008c-39.704 0-72 32.304-72 72s32.296 72 72 72 72-32.304 72-72-32.296-72-72-72zm0 128c-30.872 0-56-25.12-56-56s25.128-56 56-56 56 25.12 56 56-25.128 56-56 56z"/>
          </svg>
        </div>
        <div class="text-slate-300 text-sm ml-3">
          <span class="block text-slate-400 text-xs">Address</span>
          @if (contactInfo()?.address1) {
            <address class="font-medium not-italic block">
              {{ contactInfo()!.address1 }}
            </address>
          }
          @if (contactInfo()?.address2) {
            <address class="font-medium not-italic block mt-1">
              {{ contactInfo()!.address2 }}
            </address>
          }
        </div>
      </div>

      <!-- Fax -->
      <div class="flex items-center">
        <div class="bg-gray-300 h-10 w-10 rounded-full flex items-center justify-center shrink-0" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 fill-black" viewBox="0 0 100 100">
            <path d="M83 23h-3V11c0-3.309-2.692-6-6-6H26c-3.308 0-6 2.691-6 6v12h-3C8.729 23 2 29.729 2 38v30c0 4.963 4.037 9 9 9h9v12c0 3.309 2.692 6 6 6h48c3.308 0 6-2.691 6-6V77h9c4.963 0 9-4.037 9-9V38c0-8.271-6.729-15-15-15zM26 11h48v12H26zm0 78V59h48v30zm66-21c0 1.654-1.345 3-3 3h-9V59h3a3 3 0 1 0 0-6H17a3 3 0 1 0 0 6h3v12h-9c-1.655 0-3-1.346-3-3V38c0-4.963 4.037-9 9-9h66c4.963 0 9 4.037 9 9zm-27 0a3 3 0 0 1-3 3H38a3 3 0 1 1 0-6h24a3 3 0 0 1 3 3zm0 12a3 3 0 0 1-3 3H38a3 3 0 1 1 0-6h24a3 3 0 0 1 3 3zm21-42a3 3 0 0 1-3 3h-6a3 3 0 1 1 0-6h6a3 3 0 0 1 3 3z"/>
          </svg>
        </div>
        <div class="text-slate-300 text-sm ml-3">
          <span class="block text-slate-400 text-xs">Fax</span>
            <span class="font-medium block">+1-234-5678</span>
        </div>
      </div>
    </div>

    <!-- Separator -->
    <hr class="mt-12 mb-6 border-gray-600" />

    <!-- Bottom Section -->
    <div class="flex flex-col md:flex-row md:items-center justify-between gap-4">
      <!-- Links -->
      <ul class="flex flex-wrap gap-4 justify-center md:justify-start">
        <li class="text-sm">
          <a routerLink="/terms" class="text-slate-300 font-medium hover:text-white transition-colors">
            Terms of Service
          </a>
        </li>
        <li class="text-sm">
          <a routerLink="/privacy" class="text-slate-300 font-medium hover:text-white transition-colors">
            Privacy Policy
          </a>
        </li>
        <li class="text-sm">
          <a routerLink="/security" class="text-slate-300 font-medium hover:text-white transition-colors">
            Security
          </a>
        </li>
      </ul>

      <!-- Copyright -->
      <p class="text-sm text-slate-300 text-center md:text-right">
        © {{ currentYear() }} {{ companyName() }}. All rights reserved.
      </p>
    </div>
  </div>
</footer>